<template>
  <div>
    <div class="hidden md:block">
      <Dropdown ref="dropdown" label="Filters" size="small" type="secondary">
        <ScheduleFilterMenu>
          <template #header>
            <div class="flex items-center justify-between">
              <div class="font-semibold text-base">Filter</div>
              <div class="cursor-pointer" @click="toggleDropdown">
                <CloseIcon class="w-3 h-3 text-gray-800" />
              </div>
            </div>
          </template>
        </ScheduleFilterMenu>
      </Dropdown>
    </div>
    <div class="block md:hidden">
      <Fob class="md:hidden" type="Secondary" @click="toggleModal">
        <i class="fa-regular fa-filter w-4" />
      </Fob>
      <Modal v-if="open" title="Filter" no-footer @hide-modal="toggleModal">
        <ScheduleFilterMenu no-title />
      </Modal>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Modal from "@/components/Modal.vue";
import Dropdown from "@/components/Seranova/Dropdown/Dropdown.vue";
import Fob from "@/components/Seranova/Fobs/Fob.vue";
import CloseIcon from "@/images/x.svg?component";
import ScheduleFilterMenu from "./ScheduleFilterMenu.vue";

const open = ref(false);

const dropdown = ref(null);
const toggleModal = () => (open.value = !open.value);

const toggleDropdown = () => {
  if (dropdown.value) dropdown.value.toggleDropdown();
};
</script>

<style scoped></style>
